/**
 * PolygonRenderer — AIQ fill_blank 타이틀의 개수 토큰을 색 도형 스택으로 렌더.
 * quebon-aiq-mkt modules/polygon-renderer.tsx 포팅 (>3 그룹 색 버그 수정).
 *
 * parsePolygonTitle: 타이틀이 순수 {{n}},{{m}} 개수 토큰일 때만 number[] 반환,
 * 그 외(수학 서술형/변수/일반 텍스트)는 null → 호출부는 일반 텍스트 렌더로 폴백.
 */
import { cn } from '../../../lib/utils'

const COLORS = ['#FF6666', '#FFC809', '#26C9CB']
const BORDER_COLORS = ['#D54141', '#D77F27', '#009B9B']

// 타이틀 전체가 (공백) {{ 숫자 }} (콤마) 의 반복일 때만 매칭.
const POLYGON_TITLE_RE = /^\s*(\{\{\s*\d+\s*\}\}\s*,?\s*)+$/

export function parsePolygonTitle(title: string): number[] | null {
  if (!title || !POLYGON_TITLE_RE.test(title)) return null
  const counts = title
    .split(',')
    .map((t) => parseInt(t.replace(/[{}\s]/g, ''), 10))
    .filter((n) => Number.isInteger(n) && n > 0)
  return counts.length > 0 ? counts : null
}

function chunkRows(total: number): number[] {
  const rows: number[] = []
  let remaining = total
  while (remaining > 0) {
    const add = Math.min(3, remaining)
    rows.push(add)
    remaining -= add
  }
  return rows
}

interface PolygonRendererProps {
  counts: number[]
  shape?: 'circle' | 'square'
}

export function PolygonRenderer({ counts, shape = 'circle' }: PolygonRendererProps) {
  return (
    <div className="flex flex-wrap justify-center items-center gap-2 p-2">
      {counts.map((count, groupIndex) => {
        const colorIndex = groupIndex % COLORS.length
        return (
          <div
            key={`polygon-${groupIndex}`}
            className="flex flex-1 flex-col items-center justify-center gap-2"
          >
            {chunkRows(count).reverse().map((rowCount, rowIndex) => (
              <div key={`row-${rowIndex}`} className="flex justify-start gap-1">
                {Array.from({ length: rowCount }, (_, shapeIndex) => (
                  <div
                    key={`shape-${shapeIndex}`}
                    data-polygon-shape
                    className={cn('w-8 h-8', shape === 'square' ? '' : 'rounded-full')}
                    style={{
                      backgroundColor: COLORS[colorIndex],
                      border: `2px solid ${BORDER_COLORS[colorIndex]}`,
                    }}
                  />
                ))}
              </div>
            ))}
          </div>
        )
      })}
    </div>
  )
}
